export default "<style>\r\n\r\n  no--pointers,\r\n  .no--pointers\r\n  {\r\n    pointer-events: none;\r\n  }\r\n\r\n</style>";